enum OrganisationUnitType {
    School = "School",
    Campus = "Campus",
    YearLevel = "YearLevel",
    Faculty = "Faculty",
    Department = "Department",
}

interface OrganisationPerson {
    personId: number;
    organisationId: number;
}

interface OrganisationUnit {
    id?: number;
    type: OrganisationUnitType;
    name: string;
    children: Array<OrganisationUnit>;
    members: Array<OrganisationPerson>;
}

export { OrganisationUnitType, OrganisationUnit, OrganisationPerson };